import { NomenclatureTypeField } from './nomenclature-type-field';

export class NomenclatureTypeFieldSeparated {
    public characteristics: NomenclatureTypeField[] = [];
    public parameters: NomenclatureTypeField[] = [];
    public groups: NomenclatureTypeField[] = [];
}
